import { CmOption } from './types';

/**
 * Creates a new option object with a unique ID and specified label
 * @param label - The label text for the option (defaults to empty string)
 * @returns A new CmOption object with unique ID and specified label
 */
export const createOption = (label = ''): CmOption => ({
  id: `${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
  label,
});
